/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_IntroInputs */

const cs_settings_users_intro = /** @type {(inputs: Settings_Users_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klíče RK jsou v Integracích. Při založení makléře zadejte jeho Seznam login, aby inzeráty šly pod jeho jménem.`)
};

const en_settings_users_intro = /** @type {(inputs: Settings_Users_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office RK keys live under Integrations. When you create a broker, attach their Seznam login so listings go out under their name.`)
};

/**
* | output |
* | --- |
* | "Office RK keys live under Integrations. When you create a broker, attach their Seznam login so listings go out under their name." |
*
* @param {Settings_Users_IntroInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_intro = /** @type {((inputs?: Settings_Users_IntroInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_IntroInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_intro(inputs)
	return cs_settings_users_intro(inputs)
});